import { createEndpoint } from '@/shared/models/api';
import { ProjectInformation } from '@/app/api/morgan-thermal/project';

export const getProject = createEndpoint<ProjectInformation>(({fetch}) => (id: ProjectInformation['id']) => fetch(`/Project/Get/${id}`));